/**
 * Costanti di sicurezza condivise — vedi /design/design.md §12.
 *
 * I valori sono fissi in costanti e NON in variabili runtime per impedire
 * tampering dal client. Per modificare i thresholds vedi §14.8 (richiede
 * deploy + MFA Tier 2).
 */

export const SESSION_IDLE_MS = 30 * 60 * 1000;

export const SESSION_WARNING_MS = 28 * 60 * 1000;

export const MFA_TIER1_MAX_AGE_SEC = 43_200;

export const MFA_TIER2_MAX_AGE_SEC = 300;

/**
 * Finestra MFA "clinica": 4h, intermedia fra Tier 1 (12h) e Tier 2 (5min).
 *
 * NON e' un tier a se': non compare in `MfaTier` ne' nelle Firestore
 * Rules, dove l'helper `isMfaFresh4h` fu rimosso perche' inerte
 * (`DEBT-2026-07-29c`). E' la soglia che le Cloud Functions cliniche
 * verificano con `assertMfaFresh4h`, e vale per le scritture su anamnesi
 * e su piani alimentari paziente.
 *
 * DUPLICATO DELIBERATO di `MFA_CLINICAL_MAX_AGE_SEC` in
 * `functions/src/lib/constants.ts:18`: i due progetti non condividono
 * moduli a runtime. La parita' e' verificata da
 * `src/__tests__/piani-functions-parity.test.ts`, che importa il valore
 * server e lo confronta con questo.
 */
export const MFA_CLINICAL_MAX_AGE_SEC = 14_400;

export const EMULATOR_HOST = '127.0.0.1';
export const EMULATOR_PORTS = {
  auth: 9099,
  firestore: 8080,
  storage: 9199,
  functions: 5001,
} as const;
